export default __webpack_public_path__ + "static/media/solucionarte_logo-16.6d91772d.png";